import React, { useEffect, useState } from "react";
import TrustpilotLogo from "../../Assets/images/New/Trustpilot_logo.png";
import { Link } from "react-router-dom";

const TrustpilotRating = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(
          document.getElementsByClassName("trustpilot-widget")[0],
          true
        );
      }
    }, 0);
    return () => clearTimeout(timer);
  }, []);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= 768);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const containerStyles = {
      display: "flex",
        alignItems: "center",
        backgroundColor: "#fff",
        padding: "3px 0px",
        borderRadius: "8px",
        minWidth: isMobile ? "300px" : "200px",
        justifyContent: "center",
        border: "1px solid #e0e9f0",
    };

    const ratingStyles = {
      fontSize: isMobile ? "20px" : "24px",
      fontWeight: "bold",
      color: "#333",
    };
    const logoImageStyles = {
      width: isMobile ? "180px" : "120px",
    };

  return (
    <>
      <div style={containerStyles}>
  <Link
    to="https://www.sitejabber.com/reviews/doubtq.com"
    target="_blank"
    rel="noopener"
    style={{ color: "#ff9900", textDecoration: "none" }}
  >
  <img src={TrustpilotLogo} style={logoImageStyles} alt="Trustpilot Logo" />
  </Link>
</div>
      {/* TrustBox widget - Review Collector */}
      {/* <div
        className="trustpilot-widget"
        data-locale="en-US"
        data-template-id="56278e9abfbbba0bdcd568bc"
        data-businessunit-id="6655bdca0385994b6813eea1"
        data-style-height="52px"
        data-style-width="100%"
      >
        <Link
          to="https://www.sitejabber.com/reviews/doubtq.com"
          target="_blank"
          rel="noopener"
        >
          Trustpilot
        </Link>
      </div> */}
    </>
  );
};

const styles = {
  logo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "8px",
  },
};

export default TrustpilotRating;
